export default "__VITE_ASSET__DNWmZ_Nu__"